"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "EmailAddressSchema", {
    enumerable: true,
    get: function() {
        return EmailAddressSchema;
    }
});
const _zod = require("zod");
const EmailAddressSchema = _zod.z.string().email();
